const IGNORED_PATTERNS = [
  /loading chunk/i,
  /chunkloaderror/i,
  /failed to fetch dynamically imported module/i,
  /ResizeObserver loop/i,
  /extension/i,
  /Non-Error promise rejection/i,
];

export function shouldReportGlobalError(message) {
  const text = String(message || "").trim();
  if (!text) return false;
  return !IGNORED_PATTERNS.some((pattern) => pattern.test(text));
}
